// Tax Configuration Types (enhanced for task 4.2)

export type TaxScope = 'NATIONAL' | 'PROVINCE' | 'CATEGORY';

export interface TaxConfiguration {
  id: string;
  name: string;
  fpt_percentage: number;
  tva_percentage: number;
  effective_start_date: string;
  effective_end_date?: string | null;
  scope: TaxScope;
  scope_value?: string | null;
  is_active: boolean;
  created_by: string;
  created_at: string;
}

export interface CreateTaxConfigRequest {
  name: string;
  fpt_percentage: number;
  tva_percentage: number;
  effective_start_date: string;
  effective_end_date?: string;
  scope: TaxScope;
  scope_value?: string;
}

export interface TaxConfigurationHistory {
  id: string;
  tax_config_id: string;
  action: 'CREATED' | 'UPDATED' | 'DEACTIVATED';
  old_fpt_percentage?: number | null;
  new_fpt_percentage?: number | null;
  old_tva_percentage?: number | null;
  new_tva_percentage?: number | null;
  changed_by: string;
  changed_at: string;
}

export interface TaxChangeNotification {
  config_id: string;
  config_name: string;
  scope: string;
  scope_value?: string;
  effective_date: string;
  fpt_percentage: number;
  tva_percentage: number;
  hotels_notified: number;
  notified_at: string;
}

export interface TaxRateCalculationResponse {
  fpt_percentage: number;
  tva_percentage: number;
  applied_scope: string;
  applied_config?: TaxConfiguration;
  fallbacks_checked: string[];
}

export interface TaxConfigSearchParams {
  search?: string;
  scope?: string;
  active_only?: boolean;
  limit?: number;
  offset?: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  limit: number;
  offset: number;
  total_pages: number;
}

export const TAX_SCOPES = [
  { value: 'NATIONAL', label: 'National' },
  { value: 'PROVINCE', label: 'Province' },
  { value: 'CATEGORY', label: 'Catégorie d\'hôtel' },
] as const;

export const SCOPE_COLORS: Record<string, string> = {
  NATIONAL: 'bg-indigo-100 text-indigo-800',
  PROVINCE: 'bg-teal-100 text-teal-800',
  CATEGORY: 'bg-amber-100 text-amber-800',
};

export const RDC_PROVINCES = [
  'Kinshasa', 'Kongo Central', 'Kwango', 'Kwilu', 'Mai-Ndombe',
  'Kasaï', 'Kasaï-Central', 'Kasaï-Oriental', 'Lomami', 'Sankuru',
  'Maniema', 'Sud-Kivu', 'Nord-Kivu', 'Ituri', 'Haut-Uélé',
  'Tshopo', 'Bas-Uélé', 'Nord-Ubangi', 'Mongala', 'Sud-Ubangi',
  'Équateur', 'Tshuapa', 'Tanganyika', 'Haut-Lomami', 'Lualaba', 'Haut-Katanga',
] as const;

export const HOTEL_CATEGORIES = [
  { value: '1', label: '1 étoile ★' },
  { value: '2', label: '2 étoiles ★★' },
  { value: '3', label: '3 étoiles ★★★' },
  { value: '4', label: '4 étoiles ★★★★' },
  { value: '5', label: '5 étoiles ★★★★★' },
] as const;
